export default class ConvertObjectParamToString {
  private static _instance: ConvertObjectParamToString;
  private constructor() {}
  public convertObjectParamToStrings(querySearch: any): string {
    let queryString = "";
    for (const item in querySearch) {
      if (
        querySearch[item] &&
        typeof querySearch[item] === "object" &&
        item != " modifiedDate.lessThan" &&
        item != "modifiedDate.greaterThan" &&
        item != " decisionDate.lessThan" &&
        item != "decisionDate.greaterThan"
      ) {
        if (querySearch[item].length > 0) {
          querySearch[item].forEach((itemChid: any) => {
            queryString += `${item}=${itemChid}&`;
          });
        }
      } else if ((querySearch[item] || querySearch[item] == 0) && querySearch[item] != null) {
        queryString += `${item}=${querySearch[item]}&`;
      }
    }
    return queryString;
  }
  public convertObjectParamToStringsNull(querySearch: any): string {
    let queryString = "";
    for (const item in querySearch) {
      if (
        querySearch[item] &&
        typeof querySearch[item] === "object" &&
        item != " modifiedDate.lessThan" &&
        item != "modifiedDate.greaterThan" &&
        item != " decisionDate.lessThan" &&
        item != "decisionDate.greaterThan"
      ) {
        if (querySearch[item].length > 0) {
          querySearch[item].forEach((itemChid: any) => {
            queryString += `${item}=${itemChid}&`;
          });
        }
      } else if (querySearch[item] || querySearch[item] == 0) {
        queryString += `${item}=${querySearch[item]}&`;
      }
    }
    return queryString;
  }
  public static get instance(): ConvertObjectParamToString {
    if (this._instance === undefined) {
      this._instance = new ConvertObjectParamToString();
    }
    return this._instance;
  }
}
